// Presence.js
import React, { useCallback, useEffect, useState } from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';
import L from 'leaflet';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { getOrg } from '../controllers/org';
import Loading from '../components/loading/Loading';
import { Link } from 'react-router-dom';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;


function Presence() {
  const [comunidades, setComunidades] = useState();
  const [diocesis, setDiocesis] = useState();
  const [map, setMap] = useState(null)


  useEffect(() => {
    document.title = 'FAMA - Presencia';
    getComunidades();
  }, []);

  const onClick = useCallback((e) => {
    e.preventDefault();
    let comunidad = comunidades.filter(c => c.comunidad_id === parseInt(e.target.dataset.comunidadid))[0];
    console.log(comunidad);
    let center = [comunidad.latitude, comunidad.longitude];
    map.setView(center, 17);
  }, [map])

  async function getComunidades() {
    const org = await getOrg();
    console.log(org);
    const com = org.comunidades.filter(c => c.display_on_map);
    setComunidades(com);
    setDiocesis(org.diocesis.filter(d => com.find(c => c.diocesis_id === d.diocesis_id)));
  }

  function getRegionId(diocesisId) {
    let d = diocesis.filter(d => d.diocesis_id === diocesisId)[0];
    return d.region_id;
  }

  if (!comunidades || !diocesis) {
    return <Container className='public-page-container'>
      <Col>
        <Row><Loading /></Row>
      </Col>
    </Container>;
  }
  return (
    <Container className='public-page-container'>
      <Col>
        <Row>
          <h1>Presencia</h1>
          <p>Actualmente FAMA está presente en {comunidades.length} comunidades:</p>
        </Row>
        <Row>
          <Col lg={4} style={{height: '30rem', overflowY: 'auto', marginBottom: '2rem'}}>
            <Accordion defaultActiveKey='0'>
              {diocesis.map((d, i) => <Accordion.Item eventKey={i} key={`diocesis-${d.diocesis_id}`}>
                <Accordion.Header>{d.label}</Accordion.Header>
                <Accordion.Body>
                  {comunidades.filter(c => c.diocesis_id === d.diocesis_id)
                    .map(c => 
                      <Link 
                        key={`diocesis-${d.diocesis_id}-com-${c.comunidad_id}`} 
                        onClick={onClick} 
                        data-comunidadId={c.comunidad_id}
                        style={{display: 'block'}}
                        >
                          {c.label}
                        </Link>)}
                </Accordion.Body>
              </Accordion.Item>)}
            </Accordion>
          </Col>
          <Col lg={8} style={{height: '30rem'}}>
            <MapContainer
              center={[39.8282, -98.5795]}
              zoom={4}
              scrollWheelZoom={true}
              style={{height: '30rem'}}
              ref={setMap}
              >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              
              { comunidades.map(c =>
                <Marker position={[c.latitude, c.longitude]} key={'comunidad-' + c.comunidad_id}>
                  <Popup offset={[0, -30]}>
                    <h4>{c.label}</h4>
                    <p><a href={`mailto:region${getRegionId(c.diocesis_id)}@familiasenmisionapostolica.org`}>Contactar por email</a></p>
                  </Popup>
                </Marker>
              )}

            </MapContainer>
          </Col>
        </Row>
      </Col>
    </Container>
  );
}

export default Presence;
